import Vue from 'vue'
// import Vant from 'vant'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
// import moment from 'moment'
// import 'moment/locale/zh-cn'
import moment from 'moment-timezone'
// import moment from 'moment'
// import { router } from './router';
// import base from './common/base'
import { getOpenId } from '@/utils/auth'
// import VueRouter from 'vue-router'
import { router } from './router'

// eslint-disable-next-line no-unused-vars
// import vConsole from '@/utils/vconsole'

import 'vant/lib/index.css'
import './assets/fonts/icomoon.css'
import '@/styles/index.css' // global css
import './assets/vconsole.css'


Vue.use(VueAxios, axios)
// Vue.use(vConsole)
Vue.use(App)

// Vue.use(Vant)
// Vue.use(VueRouter)
Vue.use(VueMoment, {
  moment
})
// Vue.use(moment)

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers['Accept'] = 'application/json'
axios.defaults.headers['Content-Type'] = 'application/json'
// axios.defaults.headers['Token'] = getOpenId()
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.xsrfHeaderName = "X-CSRFToken"
// axios.defaults.xsrfCookieName = 'csrftoken'

// request拦截器
axios.interceptors.request.use(config => {
  // if (store.getters.token) {
  //   // config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  //   config.headers['Authorization'] = 'RongToken ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // let api = process.env.BASE_API + config.url
  let api = process.env.VUE_APP_SERVER_URL + config.url
  const openID = getOpenId()
  if (openID) {
    // config.headers['Authorization'] = 'Wechat ' + openID
  } else {
    console.log('no token')
  }
  if (api.search(/\?/) === -1) {
    api = api + '?openid=' + getOpenId()
  } else {
    api = api + '&openid=' + getOpenId()
  }
  config.url = api
  return config
}, error => {
  Promise.reject(error)
})


import { Toast } from 'vant';
// respone拦截器
axios.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    // const res = response.data
    // if ((res.code && res.code !== 200) || (response.status !== 200 && response.status !== 201)) {
    // if (response.status < 200 && response.status > 201) {
    //   Message({
    //     message: res.message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
    //       confirmButtonText: '重新登录',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('FedLogOut').then(() => {
    //         location.reload()// 为了重新实例化vue-router对象 避免bug
    //       })
    //     })
    //   }
    //   return Promise.reject('error')
    // } else {
    //   return response.data
    // }
    // console.log('response')
    return response.data
  },
  error => {
    if(error.response){
      if (error.response.status === 500) {
        Toast('服务器错误')
        // alert('error')
        // alert(error.response)
        // alert(error.message)
        // console.log(error.response)
      }
    }
    // console.log(process.env.NODE_ENV)
    // if (process.env.NODE_ENV !== 'production') {
    //   Message({
    //     message: error.message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }
    // if (error.response && error.response.status === 403) { // permission deina
    //   Message({
    //     message: error.response.data.detail,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }

    return Promise.reject(error)
  }
)

new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
